import { render, staticRenderFns } from "./pseudos.vue?vue&type=template&id=bc941950&scoped=true&"
import script from "./pseudos.vue?vue&type=script&lang=js&"
export * from "./pseudos.vue?vue&type=script&lang=js&"
import style0 from "./pseudos.vue?vue&type=style&index=0&id=bc941950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc941950",
  null
  
)

export default component.exports